import { LitElement, PropertyValues } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("modal-overlay")
export class ModalOverlayElement extends LitElement {

    protected override createRenderRoot() {
        return this;
    }


    protected override firstUpdated(_changedProperties: PropertyValues): void {
        super.firstUpdated(_changedProperties);
        this.addEventListener("click", this.handleClick.bind(this));
    }

    private handleClick(event: Event) {
        console.debug("Modal overlay clicked, dispatching hide-modal-requested event");
        this.dispatchEvent(new CustomEvent("hide-modal-requested", { bubbles: true, composed: true }));
    }
}